import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { SessionService } from 'src/app/services/session.service';
// import { OwlOptions } from 'ngx-owl-carousel-o';
import * as moment from 'moment';
import {
	ModalDismissReasons,
	NgbModal,
	NgbModalOptions,
} from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
	
	covidApiUrl: any;
	allCase: any = '--';
	allDeath: any = '--';
	allRecover: any = '--';
	lastUpdated: any;


	constructor(
		private formBuilder: FormBuilder,
		private http: HttpClient,
		private router: Router,
		private modalService: NgbModal,
		private spinnerService: Ng4LoadingSpinnerService
	) {}

	ngOnInit(): void { 
		$(".mobile-menu").css("display", "none"); 
		this.getCovidData();
	}

	customOptions = {
		loop: true,
		mouseDrag: false,
		touchDrag: false,
		pullDrag: false,
		dots: false,
		navSpeed: 700,
		navText: ['', ''],
		responsive: {
			0: {
				items: 1,
			},
			400: {
				items: 2,
			},
			740: {
				items: 3,
			},
			940: {
				items: 4,
			},
		},
		nav: true,
	};

	getCovidData() { 
		this.spinnerService.show();
		this.covidApiUrl = "https://corona.lmao.ninja/v2/all";
		this.http.get<any>(this.covidApiUrl).subscribe((data) => {
			
			this.allCase = data.cases;
			this.allDeath = data.deaths;
			this.allRecover = data.recovered;
			this.lastUpdated = data.updated
			this.spinnerService.hide();
		});
 	}

	
	
}
